import {
  Component,
  Input,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import {
  AuthenticationService,
  IAuthentication,
} from '@libs/authentication/services';
import { INavigationConfig } from './types/navigation-config';
import { ViewportChangeService } from '@libs/services/viewport-change';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  templateUrl: 'layout.component.html',
  // tslint:disable-next-line:component-selector
  selector: 'snag-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  private readonly viewportChangeService = inject(ViewportChangeService);
  private auth = inject(AuthenticationService);

  @Input() configuration: INavigationConfig[] = [];
  @Input() showAdminLogo: boolean = false;
  @Input() hideLayout = false;
  @Input() enableTopNav = false;

  isMobile = toSignal<boolean>(this.viewportChangeService.isMobile());
  isTabletLarge = toSignal<boolean>(this.viewportChangeService.isTabletLarge());
  user = toSignal<IAuthentication>(this.auth.user$);
}
